import { render, staticRenderFns } from "./OpenGameRoundList.vue?vue&type=template&id=40f30b7e&scoped=true&"
import script from "./OpenGameRoundList.vue?vue&type=script&lang=js&"
export * from "./OpenGameRoundList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f30b7e",
  null
  
)

export default component.exports